import { MessageCircle } from "lucide-react";
import { useLang, WHATSAPP_NUMBER } from "@/i18n";

export default function WhatsAppButton() {
  const { t } = useLang();
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t.waText)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with IP NET on WhatsApp"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping-slow" aria-hidden="true" />
      <span className="relative flex w-14 h-14 rounded-full bg-[#25D366] items-center justify-center text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 group-hover:scale-110">
        <MessageCircle size={24} fill="currentColor" strokeWidth={0} />
      </span>
    </a>
  );
}
